<template>
    <div>
        <b-row class="terms-container" id="terms-container">
            <b-col cols="12" lg="12" id="terms-content-imagen">
                <img  class="terms-banner-landing"
                     src="@/assets/images/terms-img.png" alt="Terms Banner img">
            </b-col>
            <div class="terms-content-titulo-principal">
                <p class="terms-titulo" v-html="content.titulo"></p>
            </div>
        </b-row>
        <b-row class="terms-content-parrafo mt-5">
            <b-col cols="12" lg="12" >
               <p class="terms-parrafo" v-html="content.parrafo"></p>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'section-terms',
        components: {},
        props: {content: Object},
        data: () => ({}),
        methods: {}
    }
</script>
<style scoped>
</style>